/**
 * 定义批量上报的配置
 */
export const BATCH_CONFIG = {
  /**
   * 数量阈值：攒够 10 条立刻发
   */
  MAX_COUNT: 10,
  /**
   * 时间阈值：最多等 1500ms 就发一次
   */
  MAX_WAIT_MS: 1500,
  /**
   * 单条防抖间隔时间 5000ms
   */
  INTERVAL_TIME_MS: 5000,
  /**
   * 可见上报间隔时间 2000ms
   */
  PAGE_STAY_TIME_MS: 2000
};

export const SHOW_VERSION = 501;
